import axios from 'axios';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';

const url = require('url');

const path = process.env.REACT_APP_BASE_URL + '/api/v2';
const apiVersion = 'v2';

class ProvisionService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = myEpik => {
    const urlObj = url.parse(document.location.href, true);
    // const dev = urlObj.href.indexOf('my.epik.io') !== -1;
    // if (!dev) {
    //   return this.baseURL || ProvisionService.resourcePath || ProvisionService.baseURL;
    // }
    if (myEpik || global.myEpik === 'Yes') {
      return path;
    } else if (global.myEpik === 'No') {
      return `${unifiedBaseURL()}v2`
    } else {
      return this.baseURL || ProvisionService.resourcePath || ProvisionService.baseURL;
    }
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  async searchNumber(body, provider) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    var url = "/numbers/query"
    if (provider === "Inteliquent")
      var url = "/numbers/inteliquent/query"

    const { data } = await axios.post(`${this.getBaseURL()}${url}`, body, { headers });

    // var data = {
    //   statusCode: '200',
    //   status: 'Success',
    //   tnResult: [
    //     {
    //       telephoneNumber: '2057078663',
    //       rateCenter: 'HACKLEBURG',
    //       lata: '476',
    //       province: 'AL',
    //       city: 'HACKLEBURG',
    //     },
    //     {
    //       telephoneNumber: '2057078665',
    //       rateCenter: 'HACKLEBURG',
    //       lata: '476',
    //       province: 'AL',
    //       city: 'HACKLEBURG',
    //     },
    //     {
    //       telephoneNumber: '2057078668',
    //       rateCenter: 'HACKLEBURG',
    //       lata: '476',
    //       province: 'AL',
    //       city: 'HACKLEBURG',
    //     },
    //   ],
    //   totalItems: '19256901',
    //   size: '3',
    // };
    return data;
  }

  async orderNumber(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const url = "/numbers/inteliquent/order"

    const { data } = await axios.post(`${this.getBaseURL(true)}${url}`, body, { headers });

    return data;
  }

  async getGateways() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    var { data } = await axios.get(`${this.getBaseURL()}/numbers/gateways`, { headers });
    return data.gateways;
  }

  async getAddress(numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL('la')}${apiVersion}/numbers/${numId}/e911`, { headers });
    return data;
  }

  async assignRouteInfo(numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}/numbers/${numId}/routeInfo`, {
      headers,
    });

    return data;
  }

  async getNumberOrderList(numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}/numbers/${numId}/carrier-order-list`, {
      headers,
    });

    return data;
  }

  async queryLrn(numId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}/numbers/${numId}/lrnInfo`, { headers });

    // var data = {
    //   lrn: {
    //     LRN: '16467416887',
    //     OCN: '997E',
    //     LATA: '132',
    //     CITY: 'NWYRCYZN01',
    //     RC: 'NWYRCYZN01',
    //     STATE: 'NY',
    //     JURISDICTION: 'INTERSTATE',
    //     LOCAL: 'N',
    //     LEC: 'BANDWIDTH.COM CLEC, LLC - NY',
    //     LECTYPE: 'CLEC',
    //   },
    // };

    return data;
  }

  async lrnInfoByNumber(num, lrnRoute) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL(true)}/numbers/${num}/${lrnRoute}`, {
      headers,
    });
    return data;
  }

  async updateAddress(numId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(`${unifiedBaseURL('la')}${apiVersion}/numbers/${numId}/e911`, body, {
      headers,
    });

    return data;
  }

  async removeNumberAddress(id, body) {
    var optionsAxios = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.api.token}`,
      },
      url: `${this.getBaseURL()}/numbers/${id}/e911`,
      data: body,
    };
    const { data } = await axios(optionsAxios);
    return data;
  }

  async updateNumberRoute(numId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(`${this.getBaseURL(global.vmail)}/numbers/${numId}`, body, {
      headers,
    });

    return data;
  }

  async getNewNumberOrderHistory(queryOptions){
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { page, limit, searchType, ...search } = queryOptions;

    const { data } = await axios.get(
      `${this.getBaseURL(true)}/numbers/new/orderList?page=${page}&limit=${limit}&searchType=${searchType}&search=${JSON.stringify(
        search,
      )}`,
      {
        headers,
    });

    return data;
  }
}

export default ProvisionService;
